
angular.module('bmsApp.crm.customer').controller('SiteModalFormCtrl', [
	'$scope',
	'$q',
	'$timeout',
	'$filter',
	'$modalInstance',
	'$ngBootbox',
	'InstanceSvc',
	'ContactSvc',
	'notify',
	'SiteSvc',
	'site', function (
		$scope,
		$q,
		$timeout,
		$filter,
		$modalInstance,
		$ngBootbox,
		InstanceSvc,
		ContactSvc,
		notify,
		SiteSvc,
		site) {

		$scope.isMM = InstanceSvc.instance.isMM;
		$scope.isTG = InstanceSvc.instance.isTG;
		$scope.isSM = InstanceSvc.instance.isSM;

		$scope.site = angular.extend({
			address_1: '',
			address_2: '',
			address_3: '',
			city: '',
			county: '',
			postcode: '',
			same_billing_address: true
		}, site);

		$scope.loading = true;
		$scope.processing = false;
		ContactSvc.customerOptions($scope.site.customer.id)
			.then(function (response) {
				$timeout(function () {
					$scope.$apply(function () {
						$scope.contactOptions = response.data.options;
					});
					$scope.loading = false;
				}, 0);
			});

		$scope.addressLookup = function() {
			return SiteSvc.lookup({postcode: $scope.site.postcode_lookup, houseNo: $scope.site.houseno_lookup}).then(function(response) {
				$scope.addressList = response.data.addresses;
				if ($scope.addressList.length === 1) {
					let address = $scope.addressList[0];
					$scope.site.address_1 = address.line_1 || '';
					$scope.site.address_2 = address.line_2 || '';
					$scope.site.address_3 = address.line_3 || '';
					$scope.site.city = address.city || '';
					$scope.site.county = address.county || '';
					$scope.site.postcode = address.postcode || '';
					$scope.site.showLookup = false;
				}
			}, function() {
				notify({
					message: 'Address not found',
					classes: 'error',
				});
			});
		};

		$scope.addressChanged = function(address) {
			$scope.site.address_1 = address.line_1;
			$scope.site.address_2 = address.line_2;
			$scope.site.address_3 = address.line_3;
			$scope.site.city = address.city;
			$scope.site.county = address.county;
			$scope.site.postcode = address.postcode;
			$scope.site.showLookup = false;
		};

		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit($scope.site);
			},
			errorPlacement: function (error) {
				error.appendTo('#site-errors');
			},
			errorContainer: '#site-errors'
		};

		$scope.submit = function (site) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = SiteSvc.save(site);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = site.id ? 'update' : 'create';
					modalResult.site = site;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
					$modalInstance.close(modalResult);
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.cancel = function () {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					$modalInstance.dismiss('cancel');
				});
		};

		var empty_billing_address = {
			billing_address_1: '',
			billing_address_2: '',
			billing_address_3: '',
			billing_city: '',
			billing_county: '',
			billing_postcode: ''
		};
		var billing_backup;

		$scope.sameBillingAddressChanged = function () {
			if ($scope.site.same_billing_address) {
				billing_backup = {
					billing_address_1: $scope.site.billing_address_1,
					billing_address_2: $scope.site.billing_address_2,
					billing_address_3: $scope.site.billing_address_3,
					billing_city: $scope.site.billing_city,
					billing_county: $scope.site.billing_county,
					billing_postcode: $scope.site.billing_postcode
				};
				console.info(billing_backup);
				angular.extend($scope.site, empty_billing_address);
			}
			else {
				console.info(billing_backup);
				angular.extend($scope.site, billing_backup);
			}
		};

		if ($scope.site.same_billing_address) {
			$scope.sameBillingAddressChanged();
		}
		
	}]);
